function HomePage() {
  return (
    <div className="App">
      <header className="App-header">NearU Web Application</header>
    </div>
  );
}

export default HomePage;
